var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13.598 19c2.687 0 4.072-1.68 4.072-3.8 0-1.741-1.175-3.19-2.686-3.42 1.322-.273 2.413-1.47 2.413-3.212C17.397 6.7 16.033 5 13.367 5H6v14zm-.881-8.438H8.98V7.624h3.736c1.007 0 1.637.608 1.637 1.469 0 .903-.63 1.47-1.637 1.47m.126 5.814H8.98v-3.19h3.862c1.154 0 1.784.714 1.784 1.595 0 1.008-.672 1.595-1.784 1.595"
})));
export default SvgGemBold;